import { Box, Flex, Grid, Paper, Text, Title } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { CheckedIcon, EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Preferences = () => {
  const laptop = useMediaQuery("(max-width: 1100px)");
  const { profile } = useProfileStore();
  const preferences = profile?.preferences || [];
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/goals")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("preferences")}
      </Title>
      <Grid mt={40} gutter={40}>
        {preferences.length > 0 ? (
          preferences.map((preference, index) => {
            const question = preference.title.replace(/\s?\(.*\)/, "");
            const validAnswers = preference.answers?.filter(
              (answer) => answer.text !== "Other" && answer.text !== "Інше"
            );

            return (
              <Grid.Col span={laptop ? 12 : 6} key={index}>
                <Text fw="bold">{question}</Text>

                {validAnswers.map((answer) => (
                  <Flex mt={8} gap={8} key={answer.id}>
                    <CheckedIcon />
                    <Text
                      style={{ wordBreak: "break-word", whiteSpace: "wrap" }}
                    >
                      {answer.text}
                    </Text>
                  </Flex>
                ))}

                {preference.text_answer && (
                  <Flex mt={validAnswers.length ? 12 : 8} gap={8}>
                    <Box w={20} h={20} mt={2}>
                      <CheckedIcon />
                    </Box>
                    <Text
                      style={{ wordBreak: "break-word", whiteSpace: "normal" }}
                    >
                      {preference.text_answer}
                    </Text>
                  </Flex>
                )}
              </Grid.Col>
            );
          })
        ) : (
          <Text c="#737373" p="0 0 24px 24px">
            {t("no_preferences")}
          </Text>
        )}
      </Grid>
    </Paper>
  );
};
